import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkGreyBg({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkGreyBg}>{children}</span>;
}
